import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const ManufacturingPage = lazy(() => import('../pages/manufacturing/page'));
const OemOdmPage = lazy(() => import('../pages/oem-odm/page'));
const HeritagePage = lazy(() => import('../pages/heritage/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/manufacturing',
    element: <ManufacturingPage />,
  },
  {
    path: '/oem-odm',
    element: <OemOdmPage />,
  },
  {
    path: '/heritage',
    element: <HeritagePage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
